import { LucideIcon } from 'lucide-react';

interface ProcessStepProps {
  step: number;
  title: string;
  description: string;
  icon: LucideIcon;
  isLast?: boolean;
}

export const ProcessStep = ({ step, title, description, icon: Icon, isLast = false }: ProcessStepProps) => {
  return (
    <div className="relative flex flex-col items-center text-center group">
      {/* Connector Line */}
      {!isLast && (
        <div className="absolute top-12 left-1/2 transform -translate-x-1/2 w-px h-20 bg-gradient-to-b from-primary/50 to-transparent hidden lg:block" />
      )}
      
      {/* Step Circle */}
      <div className="relative z-10 w-24 h-24 bg-gradient-to-br from-primary to-primary/80 rounded-full flex items-center justify-center mb-6 shadow-lg group-hover:shadow-xl transition-all duration-300 group-hover:scale-110">
        <Icon className="w-10 h-10 text-white" />
        <div className="absolute -top-2 -right-2 w-8 h-8 bg-secondary rounded-full flex items-center justify-center text-white font-bold text-sm">
          {step}
        </div>
      </div>

      {/* Content */}
      <div className="space-y-3 max-w-xs">
        <h3 className="text-xl font-bold text-gray-900">
          {title}
        </h3>
        <p className="text-gray-600 leading-relaxed">
          {description}
        </p>
      </div>
    </div>
  );
};